import { render, staticRenderFns } from "./NormalTitle.vue?vue&type=template&id=2bb904d2&scoped=true"
import script from "./NormalTitle.vue?vue&type=script&lang=js"
export * from "./NormalTitle.vue?vue&type=script&lang=js"
import style0 from "./NormalTitle.vue?vue&type=style&index=0&id=2bb904d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb904d2",
  null
  
)

export default component.exports